import { render, staticRenderFns } from "./MergeAccountsModal.vue?vue&type=template&id=5a7154d6"
import script from "./MergeAccountsModal.vue?vue&type=script&lang=js"
export * from "./MergeAccountsModal.vue?vue&type=script&lang=js"
import style0 from "./MergeAccountsModal.vue?vue&type=style&index=0&id=5a7154d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports